export const stateLabel = {
    KE: 'County',
    PY: 'Department',
    UY: 'Department',
    AR: 'Province'
  };
  